import React, { useState, useEffect } from 'react';
import styles from './Login.module.css';
import { getApiUrl } from '../../api';
import { toast } from 'react-toastify';
import { useLanguage } from '../../context/LanguageContext';

const Signup = ({ onClose, onAuth }) => {
  const { t } = useLanguage();
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [packageId, setPackageId] = useState('');
  const [packages, setPackages] = useState([]);

  useEffect(() => {
    (async () => {
      try {
        const res = await fetch(getApiUrl('/api/pricing'));
        if (!res.ok) return;
        const data = await res.json();
        setPackages(data.packages || []);
      } catch (err) {
        // ignore
      }
    })();
  }, []);

  const handleSignup = async (e) => {
    e.preventDefault();
    try {
      const res = await fetch(getApiUrl('/api/auth/signup'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ name, email, password, packageId: packageId || null }),
      });

      // Safely parse response — backend may return plain text on validation errors
      const text = await res.text();
      let data = {};
      try { data = JSON.parse(text); } catch { data = { message: text || 'Signup failed' }; }

      if (!res.ok) return toast.error(data.message || data.errors?.[0]?.msg || 'Signup failed');
      if (data.token) localStorage.setItem('token1', data.token);
      if (data.user) localStorage.setItem('user1', JSON.stringify(data.user));
      if (onAuth) onAuth();
      if (onClose) onClose();
    } catch (err) {
      console.error(err);
      toast.error('Signup error');
    }
  };

  return (
    <div className="d-flex justify-content-center w-100">
      <div className={`card shadow-sm border-0 ${styles.authCard} position-relative`}>
        {onClose && (
          <button type="button" className={`btn-close ${styles.authClose}`} onClick={onClose} aria-label="Close" />
        )}

        <div className="card-body p-4">
          <div className={`${styles.authLogo} mb-3`}>
            <svg width="30" height="30" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="40" cy="40" r="40" fill="#E0E7FF" />
              <path d="M35 25C35 25 30 30 30 35C30 45 35 50 40 50C45 50 50 45 50 35C50 30 45 25 40 25M40 25V50M50 35H30" stroke="#6B5FFF" strokeWidth="2" strokeLinecap="round" />
            </svg>
          </div>

          <h5 className="card-title text-center mb-4">{t('createAccount', 'Create your account')}</h5>

          <form onSubmit={handleSignup}>
            <div className="mb-3">
              <label htmlFor="name" className="form-label">{t('businessNameLabel', 'Full name')}</label>
              <input
                id="name"
                type="text"
                className="form-control"
                value={name}
                onChange={(e) => setName(e.target.value)}
                required
              />
            </div>

            <div className="mb-3">
              <label htmlFor="email" className="form-label">{t('emailLabel', 'Email')}</label>
              <input
                id="email"
                type="email"
                className="form-control"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>

            <div className="mb-3">
              <label htmlFor="password" className="form-label">{t('passwordLabel', 'Password')}</label>
              <input
                id="password"
                type="password"
                className="form-control"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </div>

            <div className="mb-4">
              <label htmlFor="package" className="form-label">{t('chooseYourPlan', 'Choose a plan')}</label>
              <select
                id="package"
                className="form-select"
                value={packageId}
                onChange={(e) => setPackageId(e.target.value)}
              >
                <option value="">{t('noPlanSelected', 'No plan selected')}</option>
                {packages.map((p) => (
                  <option key={p._id} value={p._id}>
                    {p.name} — ${p.price}
                  </option>
                ))}
              </select>
            </div>

            <div className="d-grid">
              <button type="submit" className="btn btn-primary">{t('signUp', 'Sign up')}</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Signup;
